import type { ComponentType } from 'react';
import { MEACFooter } from '@provider-directory/components/custom/meac/footer/footer';
import { MEACHeaderWrapper } from '@provider-directory/components/custom/meac/header/header-wrapper';
import { MontefioreFooter } from '@provider-directory/components/custom/montefiore/footer/footer';
import { MontefioreMmcHeaderWrapper } from '@provider-directory/components/custom/montefiore/header/header-wrapper';
import { WhiteplainsFooter } from '@provider-directory/components/custom/whiteplains/whiteplains-footer';
import { MontefioreWphHeaderWrapper } from '@provider-directory/components/custom/whiteplains/whiteplains-header-wrapper';
import {
  ContextKeySchema,
  ClientOrgContextKey,
} from '@provider-directory/types/organizations.contracts';

export interface ClientOrgComponents {
  headerContent?: ComponentType<{ className?: string }>;
  footerContent?: ComponentType<{ className?: string }>;
}

export const CLIENT_ORG_COMPONENTS: Record<
  ClientOrgContextKey,
  ClientOrgComponents
> = {
  [ContextKeySchema.enum.montefiore_mmc]: {
    headerContent: MontefioreMmcHeaderWrapper,
    footerContent: MontefioreFooter,
  },
  [ContextKeySchema.enum.montefiore_wph]: {
    headerContent: MontefioreWphHeaderWrapper,
    footerContent: WhiteplainsFooter,
  },
  [ContextKeySchema.enum.montefiore_meac]: {
    headerContent: MEACHeaderWrapper,
    footerContent: MEACFooter,
  },
  [ContextKeySchema.enum.acme]: {},
};
